<div class="modal-header">
  <h3>Site Details</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <div class="row">
    @for (item of siteMap | keyvalue: keyValuePairDefaultOrder; track item) {
      <div class="col-12 col-lg-3 d-inline">
        <label class="label d-inline-block"
          >{{ item.key }}
          @if (item.value !== '') {
            <span>:</span>
          }
        </label>
        <p class="d-inline-block ps-1">{{ item.value }}</p>
      </div>
    }
  </div>
  <div class="row pt-3" style="height: 300px">
    <div class="col">
      <h3>Site Vendors</h3>
      <app-site-vendors-grid
        [gridName]="'AdminClientSiteVendors'"
        [suppliedQueryData]="suppliedGridQueryData"
      ></app-site-vendors-grid>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="col-2">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>
</div>
